import { render, staticRenderFns } from "./Filters.vue?vue&type=template&id=fb1611fe"
import script from "./Filters.vue?vue&type=script&lang=ts"
export * from "./Filters.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fb1611fe')) {
      api.createRecord('fb1611fe', component.options)
    } else {
      api.reload('fb1611fe', component.options)
    }
    module.hot.accept("./Filters.vue?vue&type=template&id=fb1611fe", function () {
      api.rerender('fb1611fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/view-editor/Filters.vue"
export default component.exports